const BASE = 10;
const RATE = 10;
const MIN_DURATION = 15;
const MAX_DURATION = 90;
const STEP = 5;

/**
 * Proposes a video duration in seconds based on the track distance in meters.
 * Uses a square root curve (base + rate * sqrt(km)), snaps to the nearest STEP (5s),
 * and clamps between MIN_DURATION (15s) and MAX_DURATION (90s).
 */
export function proposeDuration(totalDistanceMeters: number): number {
  if (totalDistanceMeters === undefined || totalDistanceMeters === null || Number.isNaN(totalDistanceMeters)) {
    return MIN_DURATION;
  }
  const km = Math.max(0, totalDistanceMeters) / 1000;
  const raw = BASE + RATE * Math.sqrt(km);
  const snapped = Math.round(raw / STEP) * STEP;
  return Math.max(MIN_DURATION, Math.min(MAX_DURATION, snapped));
}
